import hyRequest from '@/service'
import { IDataType } from '@/service/types'

// 查询菜单列表
export function listMenu(query: any) {
  return hyRequest.get<IDataType>({
    url: '/system/menu/list',
    params: query
  })
}

// 查询菜单详细
export function getMenu(menuId: string | number) {
  return hyRequest.get<IDataType>({
    url: '/system/menu/' + menuId
  })
}

// 查询菜单下拉树结构
export function treeselect() {
  return hyRequest.get<IDataType>({
    url: '/system/menu/treeselect'
  })
}

// 根据角色ID查询菜单下拉树结构
export function roleMenuTreeselect(roleId: string | number) {
  return hyRequest.get<IDataType>({
    url: '/system/menu/roleMenuTreeselect/' + roleId
  })
}

// 新增菜单
export function addMenu(data: any) {
  return hyRequest.post<IDataType>({
    url: '/system/menu',
    data
  })
}

// 修改菜单
export function updateMenu(data: any) {
  return hyRequest.put<IDataType>({
    url: '/system/menu',
    data
  })
}

// 删除菜单
export function delMenu(menuId: string | number) {
  return hyRequest.delete<IDataType>({
    url: '/system/menu/' + menuId
  })
} 

// 获取路由
export const getRouters = () => {
  return hyRequest.get<IDataType>({
    url: '/system/menu/getRouters',
  })
}